import { render, staticRenderFns } from "./BuscaClienteContato.vue?vue&type=template&id=e91508aa&scoped=true"
import script from "./BuscaClienteContato.vue?vue&type=script&lang=js"
export * from "./BuscaClienteContato.vue?vue&type=script&lang=js"
import style0 from "./BuscaClienteContato.vue?vue&type=style&index=0&id=e91508aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91508aa",
  null
  
)

export default component.exports